export function isEnoughSpace({
  viewportRect,
  direction,
  containerRect,
  childrenRect,
  popoverRect,
  customPadding
}) {
  switch (direction) {
    case 'right':
      return viewportRect.right > containerRect.left + childrenRect.right + customPadding + popoverRect.width;
    case 'left':
      return viewportRect.left < containerRect.left + childrenRect.left - customPadding - popoverRect.width;
    case 'top':
      return viewportRect.top < containerRect.top + childrenRect.top - customPadding - popoverRect.height;
    case 'bottom':
      return viewportRect.bottom > containerRect.top + childrenRect.bottom + customPadding + popoverRect.height;
  }
}